import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";

const defaultPositioningHandler = ({ width, left, bottom }) => ({
  width,
  top: bottom,
  left,
});

export const DynamicPositioningPortal = ({
  children,
  parentRef,
  positionHandler = defaultPositioningHandler,
}) => {
  const [style, setStyle] = useState({});
  useEffect(() => {
    setStyle({
      zIndex: 9999,
      ...((positionHandler &&
        positionHandler(parentRef?.getBoundingClientRect() || {})) ||
        {}),
    });

    return () => {};
  }, [parentRef]);

  return createPortal(
    React.cloneElement(children, {
      ...children.props,
      style,
    }),
    document.body
  );
};
